import { TOKEN } from './constants';

export const geocoder = new MapboxGeocoder({
  accessToken: TOKEN,
  countries: 'us',
  placeholder: 'Enter your address', // place holder text
  marker: false, // drop a marker?
  zoom: 16, // zoom range once geocoded
  bbox: [-118.944112, 32.806553, -117.644787, 34.822766],
  types: 'address',
});
